module.exports = __webpack_public_path__ + "static/media/ex8.183b807f.jpg";